import {appHasCapability} from './app.js';

const toggleReminderBanners = async () => {
  const hideBanner = await appHasCapability('reminders-cash-shipment');
  document.querySelectorAll('.js-reminder-banner').forEach(banner => 
      banner.classList.toggle('d-none', hideBanner));
};

export {toggleReminderBanners};